class BundleContents extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    if (!this.els.slide || this.els.slide.elements.length < 3) return

    setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 300)
  }

  setupCarousel() {
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))

    let desktopSlideCount = this.els.slides?.element.dataset.numberOfSlides || 0
    if (desktopSlideCount > 4) {
      desktopSlideCount = 4
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.25,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 700px)': {
            slides: {
              perView: 2.7,
              spacing: 2,
            },
          },
          '(min-width: 1000px)': {
            slides: {
              perView: desktopSlideCount,
              spacing: 2,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els.next?.element,
          previous: this.els.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('bundle-contents')) {
  customElements.define('bundle-contents', BundleContents)
}
